export default __webpack_public_path__ + "static/bestie-3-85a5b5f2fb4ef6914811fc0ec5846454.webp";